// @flow
import type { Employee, Id } from '../types';
import { find, propEq } from 'rambda';

export const findUserName = (userId: Id, employees: Employee[]) => {
  const employee = find(propEq('id', userId), employees);
  return employee ? employee.name : '';
};

